import { Icons } from '@icons';
import dayjs, { Dayjs } from 'dayjs';
import { NotificationApi } from './notification-api.model';

export class Notification {
  id: string;
  title: string;
  description: string;
  createdAt: Dayjs;
  // app custom properties
  icon: Icons = Icons.IC_NEWS;
  read: boolean;

  constructor(resource: NotificationApi) {
    this.id = resource.id;
    this.title = resource.title;
    this.description = resource.description;
    this.createdAt = dayjs(resource.created_at);
    this.read = !!resource.read_at;
  }
}
